import 'webpack-jquery-ui/autocomplete'
import 'webpack-jquery-ui/css'

const PlugInWebpackJqueryUiAutocomplete = {
  load: function(selectorContainer, selectorInput, autocompleteUrl) {
    const searchInput = $(`${selectorContainer} ${selectorInput}`);

    $(searchInput).length && $(searchInput).autocomplete({
      source: function(request, response) {
        $.ajax({
          url: autocompleteUrl,
          dataType: 'json',
          data: {
            keyword: request.term
          },
          success: function(data) {
            response(data.names);
          }
        })
      }
    });
  },
  loads: function() {
    PlugInWebpackJqueryUiAutocomplete.load('#tag.index', '#question_tag_search_form_keyword', questionTagsAutocompleteUrl);
  }
};

$(document).on('turbolinks:load', function() {
  PlugInWebpackJqueryUiAutocomplete.loads();
});
